import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-offline-quote',
  templateUrl: './offline-quote.component.html',
  styleUrls: ['./offline-quote.component.css']
})
export class OfflineQuoteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
